
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apis from "../../../../lib/apis/apis";
import {apiHeaders} from "../../../../lib/apiHeader";
import {getAllAppointment} from "../index";
import {getSlotsArrays} from "../../../../services/utills";

export const getAllExistingUser = createAsyncThunk("getAllExistingUser", async (data, { getState }) => {
    const {search,pageLimit,filterBy,currentPage} = getState()?.bookAppointmentStore
        try {
            const response = await axios.get(apis.get_all_existing_user+`${filterBy}&limit=${pageLimit}&page=${currentPage}${search!=='' ? `&search=${search}`:'' }`, {
                headers: apiHeaders(),
            });
            if (response?.data?.success === "true") {  
                return response?.data?.data;
            }else {
                return [];
            }
        } catch (err) {

            return  []
        }
    }
);
export const getAllExistingUserCards = createAsyncThunk("getAllExistingUserCards", async (id, { dispatch }) => {
        try {
            const response = await axios.get(apis.user_existing_card+id, {
                headers: apiHeaders(),
            });
           return response?.data
        } catch (err) {
            return  err?.response
        }
    }
);
// export const getServicesCategory = createAsyncThunk(
//     "getServicesCategory",
//     async (_, { getState }) => {
//         const { Search } = getState()?.bookAppointmentStore;
//
//         try {
//             const response = await axios.get(apis.get_services_category, {
//                 headers: apiHeaders(),
//                 params: {
//                     ...(Search !== '' && { Search }), // only include `search` if not empty
//                 },
//             });
//
//             if (response?.data?.success === "true") {
//                 return response?.data?.data;
//             } else {
//                 return [];
//             }
//         } catch (err) {
//             return [];
//         }
//     }
// );
export const getServicesCategory = createAsyncThunk(
    "getServicesCategory",
    async (search = null, { getState }) => {  // Accept optional search parameter
        const stateSearch = getState()?.bookAppointmentStore?.Search;
        const effectiveSearch = search !== null ? search : stateSearch;

        try {
            const response = await axios.get(apis.get_services_category, {
                headers: apiHeaders(),
                params: {
                    ...(effectiveSearch !== '' && { Search: effectiveSearch }),
                },
            });
            if (response?.data?.success === "true") {
                return response?.data?.data;
            } else {
                return [];
            }
            // ... rest of the code
        } catch (err) {
            return [];
        }
    }
);

// Then you can call it with empty search explicitly:
export const getCrmAllPlans = createAsyncThunk("getCrmAllPlans", async () => {
        try {
            const response = await axios.get(apis.get_all_plan, {
                headers: apiHeaders(),
            });
            if (response?.data?.success === "true") {
                return response?.data?.data;
            }else {
                return {};
            }
        } catch (err) {
            return  {}
        }
    }
);
export const getCrmAllServices = createAsyncThunk("getCrmAllServices", async () => {
    try {
        const response = await axios.get(apis.get_all_services, {
            headers: apiHeaders(),
        });
        if (response?.data?.success === "true") {
            return response?.data?.data;
        }else {
            return {};
        }
    } catch (err) {
        return  {}
    }
}
);
export const getCrmAppointmentHolidays = createAsyncThunk("getCrmAppointmentHolidays", async (data) => {
        try {
            const response = await axios.get(apis.appointment_holiday+data?.date+`${data?.staff_id ? `&staff_id=${data?.staff_id}`:''}`, {
                headers: apiHeaders(),
            });

            if (response?.data?.success === "true") {
                return response?.data?.data;
            }else {
                return {};
            }
        } catch (err) {
            return  {}
        }
    }
);
export const getCrmAppointmentSchedule = createAsyncThunk("getCrmAppointmentSchedule", async (data) => {
        try {
            const response = await axios.post(apis.appointment_schedule,{...data}, {
                headers: apiHeaders(),
            });
            if (response?.data?.success === 'true' && response?.data?.data){
                if (typeof response?.data?.data === 'object'){
                    return  getSlotsArrays(Object.values(response?.data?.data))
                }else {
                    return  getSlotsArrays(response?.data?.data)

                }
            }else {
                return {};
            }
        } catch (err) {
            return  {}
        }
    }
);


export const crmGuestUser = createAsyncThunk('crmGuestUser', async (data) => {
    try {
        const response = await axios.post(apis.appointment_guest_user, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})

// delete card 
export const deleteUserCard = createAsyncThunk('deleteUserCard', async (data) => {
    try {
        const response = await axios.post(apis.delete_card, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})



//  default card 
// 
export const defaultUserCard = createAsyncThunk('defaultUserCard', async (data) => {
    try {
        const response = await axios.post(apis.default_card_api, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const crmCreateAppointment = createAsyncThunk('crmCreateAppointment', async (data) => {
    try {
        const response = await axios.post(apis.create_appointment, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const crmCreatePlanAppointment = createAsyncThunk('crmCreatePlanAppointment', async (data) => {
    try {
        const response = await axios.post(apis.create_appointment_plan, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const crmCreateGiftCardAppointment = createAsyncThunk('crmCreateGiftCardAppointment', async (data) => {
    try {
        const response = await axios.post(apis.create_giftCard, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const crmUpdateAppointment = createAsyncThunk('crmUpdateAppointment', async (data) => {
    try {
        const response = await axios.post(apis.update_appointment, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const crmCheckoutAppointment = createAsyncThunk('crmCheckoutAppointment', async (data) => {
    try {
        const response = await axios.post(apis.checkout_appointment, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})

// Validates a gift card for the CRM payment modals.
//
// Deliberately has no reducer case: the booking widget's ApplyGiftCard writes the
// result into bookingWidgetStore.gifts, and reusing that here would leak a card
// between screens and outlive the modal that applied it. The caller keeps the
// result in local state instead. It also returns the error rather than toasting,
// so the modal can show the message inline against its own input.
export const crmCheckGiftCard = createAsyncThunk('crmCheckGiftCard', async (data) => {
    try {
        const response = await axios.post(apis.Gift_card_booking, {...data}, {
            headers: apiHeaders()
        })
        if (response?.data?.success === 'true') {
            return {ok: true, data: response?.data?.data, message: response?.data?.message}
        }
        return {ok: false, message: response?.data?.errors || 'This gift card could not be applied.'}
    } catch (err) {
        const errors = err?.response?.data?.errors
        return {ok: false, message: Array.isArray(errors) ? errors[0] : (errors || 'This gift card could not be applied.')}
    }
})

export const crmCreateCard = createAsyncThunk('crmCreateCard', async (data) => {
    try {
        const response = await axios.post(apis.create_crm_card, {...data},{
            headers: apiHeaders()
        })
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})
export const rescheduleAppointment = createAsyncThunk('rescheduleAppointment', async (data,{dispatch}) => {
    try {
        const response = await axios.post(apis.reschedule_appointment, {...data},{
            headers: apiHeaders()
        })
        if (response?.data?.success === 'true'){
           await dispatch(getAllAppointment())
        }
        return  response?.data
    }catch (err){
        //console.log(err)
        return err?.response?.data
    }
})

export const getAppointmentById = createAsyncThunk("getAppointmentById", async (id) => {
    try {
        const response = await axios.get(apis.appointment_by_id+id, {
            headers: apiHeaders(),
        });
        return response?.data?.data;
    } catch (err) {
        return  {}
    }
});
export const getCustomerById = createAsyncThunk("getCustomerById", async (id) => {
    try {
        const response = await axios.get(apis.customer_by_id+id, {
            headers: apiHeaders(),
        });
        return response?.data?.data;
     } catch (err) {
        return  {}
    }
});

export const updateHolidaySchedule =createAsyncThunk("updateHolidaySchedule",async (data)=>{
    return data
})
export const updateCrmFilters = createAsyncThunk('updateCrmFilters', async (data) => {
    return data
})


export const bookAppointmentSlice = createSlice({
  name: "bookAppointmentSlice",
  initialState: {
    existingUsers: [],
    selectedUserCard: [],
    servicesCategory: [],
    servicesCategoryLoading: false,
    crmAllPlans: [],
    CrmAllServices: [],
    userDetails: {},
    appointmentHolidays: [],
    appointmentSchedule: [],
    search: '',
    Search: "",
    pageLimit: 10,
    filterBy: 'All',
    currentPage: 1,
    delcard: [],
  },
  reducers: {
    resetBookAppointmentStore: (state) => {
      return {
        existingUsers: [],
        selectedUserCard: [],
        servicesCategory: [],
        servicesCategoryLoading: false,
        crmAllPlans: [],
        CrmAllServices: [],
        userDetails: {},
        appointmentHolidays: [],
        appointmentSchedule: [],
        search: '',
        Search: "",
        pageLimit: 10,
        filterBy: 'All',
        currentPage: 1,
        delcard: [],
      };
    },
  },
    extraReducers: (builder) => {
        builder.addCase(getAllExistingUser.fulfilled, (state, action) => {
            state.existingUsers = action.payload || [] ;
        });
        // 
        builder.addCase(deleteUserCard.fulfilled, (state, action) => {
            state.delcard = action.payload || [] ;
        });
        builder.addCase(getServicesCategory.pending, (state) => {
            state.servicesCategoryLoading = true;
        });
        builder.addCase(getServicesCategory.fulfilled, (state, action) => {
            state.servicesCategory = action.payload ;
            state.servicesCategoryLoading = false;
        });
        builder.addCase(getServicesCategory.rejected, (state) => {
            state.servicesCategoryLoading = false;
        });
        builder.addCase(getAllExistingUserCards.fulfilled, (state, action) => {
            state.selectedUserCard = action.payload ;
        });
    
        builder.addCase(getCrmAllPlans.fulfilled, (state, action) => {
            state.crmAllPlans = action.payload ;
        });
        builder.addCase(getCrmAllServices.fulfilled, (state, action) => {
            state.CrmAllServices = action.payload ;
        });
        builder.addCase(getCrmAppointmentHolidays.fulfilled, (state, action) => {
            state.appointmentHolidays = action.payload ;
        });
        builder.addCase(getCrmAppointmentSchedule.fulfilled, (state, action) => {
            state.appointmentSchedule = action.payload ;
        });
        builder.addCase(updateHolidaySchedule.fulfilled, (state, action) => {
            const {schedule} = action?.payload
            if (typeof schedule === 'object'){
                state.appointmentSchedule =  getSlotsArrays(Object.values(schedule))
            }else {
                state.appointmentSchedule=  getSlotsArrays(schedule)
            }
            state.appointmentHolidays = action.payload?.holidays ;
        });
        builder.addCase(updateCrmFilters.fulfilled, (state, action) => {
            const {filterBy,pageLimit,search,currentPage,Search} = action?.payload
            if (filterBy){
                state.filterBy = filterBy ;
            }
            if (pageLimit){
                state.pageLimit = pageLimit ;
            }
            if (search){
                state.search = search === 'reset' ? '' : search ;
            }
            if(Search){
                state.Search = Search === 'reset' ? '' : Search ;
            }
            if (currentPage){
                state.currentPage = currentPage ;
            }
        });


    },
});
export const { resetBookAppointmentStore } = bookAppointmentSlice.actions;
export default bookAppointmentSlice.reducer;
